import { render, staticRenderFns } from "./forex-banner.vue?vue&type=template&id=95d0f51c&scoped=true"
import script from "./forex-banner.vue?vue&type=script&lang=js"
export * from "./forex-banner.vue?vue&type=script&lang=js"
import style0 from "./forex-banner.vue?vue&type=style&index=0&id=95d0f51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d0f51c",
  null
  
)

export default component.exports